export const SUBSCRIPTION_DETAILS_REQUEST = "SUBSCRIPTION_DETAILS_REQUEST"
export const SUBSCRIPTION_DETAILS_SUCCESS = "SUBSCRIPTION_DETAILS_SUCCESS"
export const SUBSCRIPTION_DETAILS_FAIL = "SUBSCRIPTION_DETAILS_FAIL"
